import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import LayoutWithOutNavBar from '../../components/layout/LayoutWithOutNavBar';
import { verifyEmail } from '../../services/userAPIService';

const EmailVerificationPage = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmailToken = async () => {
      try {
        const response = await verifyEmail(token);
        setStatus('success');
        setMessage(response.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.message || 'Die E-Mail-Verifizierung ist fehlgeschlagen. Bitte versuche es erneut oder fordere einen neuen Verifizierungslink an.');
      }
    };

    verifyEmailToken();
  }, [token]);

  return (
    <LayoutWithOutNavBar>
      <div className="min-h-screen hero bg-base-200">
        <div className="hero-content flex-col w-full max-w-md py-8 px-4">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold">
              {status === 'verifying' && 'E-Mail wird verifiziert'}
              {status === 'success' && 'E-Mail verifiziert'}
              {status === 'error' && 'Verifizierung fehlgeschlagen'}
            </h1>
            <div className={`h-1 w-24 mx-auto mt-3 rounded-full ${
              status === 'verifying' ? 'bg-primary' : 
              status === 'success' ? 'bg-success' : 
              'bg-error'
            }`}></div>
          </div>

          <div className="card w-full shadow-2xl bg-base-100">
            <div className="card-body text-center space-y-6">
              {status === 'verifying' && (
                <>
                  <div className="flex justify-center">
                    <span className="loading loading-spinner loading-lg text-primary"></span>
                  </div>
                  <p className="text-base-content/80">
                    Deine E-Mail-Adresse wird gerade verifiziert...
                  </p>
                </>
              )}

              {status === 'success' && (
                <>
                  <div className="flex justify-center">
                    <div className="rounded-full bg-success/10 p-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                  <p className="text-base-content/80">
                    Deine E-Mail-Adresse wurde erfolgreich verifiziert. Du kannst dich jetzt anmelden und alle Funktionen nutzen.
                  </p>
                  <Link to="/login" className="btn btn-primary w-full">
                    Zum Login
                  </Link>
                </>
              )}

              {status === 'error' && (
                <>
                  <div className="flex justify-center">
                    <div className="rounded-full bg-error/10 p-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                      </svg>
                    </div>
                  </div>
                  <p className="text-base-content/80">
                    {message}
                  </p>
                  <Link to="/login" className="btn btn-primary w-full">
                    Zurück zum Login
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </LayoutWithOutNavBar>
  );
};

export default EmailVerificationPage; 